import { Injectable } from '@angular/core';
// import { HierarchyMapping } from 'src/app/constants/hierarchy_map.cnst';
import { isEmptyField } from './stock-chart-shared/stock-chart-shared-services/stock-chart-util.service';
import { isNumber } from 'util';
import { HierarchyMapping } from '../../constants/StockChart/stock-chart-api-constants';

@Injectable({
  providedIn: 'root'
})
export class StockChartGeographicalDataService {
  hierarchyMapping = JSON.parse(JSON.stringify(HierarchyMapping));
  locationSplit = '$$';

  constructor() { }

  getLocation(location: string, index: number) {
    const splitLocations = location.split(this.locationSplit);
    const properIndex = splitLocations.length - index;
    if (properIndex < 0) {
      console.log('Index out of bounds returning last location');
      return splitLocations[splitLocations.length - 1 ];
    }
    return splitLocations[properIndex];
  }

  getParent(location: string, hierarchyId: string = 'geo', index: number) {
    const splitLocations = location.split(this.locationSplit);
    const properIndex = splitLocations.length - index;
    const hierarchyMap = this.hierarchyMapping[hierarchyId];
    if (properIndex < 0) {
      console.log('Index out of bounds returning parent');
      return hierarchyMap[splitLocations.length - 1 ];
    }
    return hierarchyMap[properIndex];
  }

  getChild(location: string, hierarchyId: string = 'geo') {
    const splitLocations = location.split(this.locationSplit);
    const hierarchyMap = this.hierarchyMapping[hierarchyId];
    return hierarchyMap[splitLocations.length];
  }

  extractLocationInformation(config: any, location: string, hierarchyId) {
    let infoObj = this.getLocationInformation(config, location, hierarchyId);
    if (config.allParents) {
      infoObj.parentsArray = [];
      let configObject = {
        parent: true,
        location: true,
        child: true
      };
      let loc = location.split(this.locationSplit);
      while (loc.length > 1) {
        loc.pop();
        location = loc.join(this.locationSplit);
        let tmpObj = this.getLocationInformation(configObject, location, hierarchyId);
        infoObj.parentsArray.push(tmpObj);
        loc = location.split(this.locationSplit);
      }
      infoObj.parentsArray.reverse();
    }
    return infoObj;
  }

  getLocationInformation(config: any, location: string, hierarchyId) {
    let infoObj: any = {};
    if (config.location) {
      const index = isNumber(config.location) ? config.location : 1;
      infoObj.location = this.getLocation(location, index);
      infoObj.rawLocation = location;
    }
    if (config.child) {
      infoObj.child = this.getChild(location, hierarchyId);
    }
    if (config.parent) {
      const index = isNumber(config.location) ? config.location  : 1;
      infoObj.parent = this.getParent(location, hierarchyId, index);
    }
    return infoObj;
  }
}
